class SiteFunctions {


  constructor() {


    this.bodyElement = document.querySelector("body");


    this.mainElement = document.querySelector("#main");


    this.loginForm = document.querySelector(".placeholder-form");


    this.mobileOpen = document.querySelector(".header__mobile-burger");


    this.mobileClose = document.querySelector(".header__mobile-close");


    this.menuWrapper = document.querySelector(".header__position-wrapper");


    this.closeLoginFormIcon = this.loginForm.querySelector(


      ".header__close-form"


    );


    this.menuTopItems = [


      ...document.querySelectorAll(".header__menu-list .menu-item"),


    ];


    this.topHeaderLoginLinks = document.querySelectorAll(


      ".header__sign-in-text"


    );


    this.quizAnswerItems = document.querySelectorAll(".footer__answers-item");


    this.quizMiddleContentPart = document.querySelector(


      ".footer__quiz-content"


    );


    this.quizItems = document.querySelectorAll(".footer__quiz");


    this.quizBackLink = document.querySelector(".footer__back-link");





    this.openMobileMenu();


    this.injectMenuItems();


    this.handleQuiz();


    this.handleQuizBackLink();


  }





  handleQuiz() {


    let currentLanguage = document.documentElement.lang;





    this.quizAnswerItems.forEach((answerItem) => {


      answerItem.addEventListener("click", () => {


        const quizAction = answerItem.dataset.quizaction;





        if (quizAction && quizAction.startsWith("http")) {


          window.location.href = quizAction;


          return;


        }





        this.quizItems.forEach((quizItem) => {


          quizItem.style.display = "none";





          if (quizItem.dataset.quizid === quizAction) {


            const backLinkAction =


              quizItem.closest(".footer__quiz").previousElementSibling.dataset


                .quizid;





            quizItem.style.display = "block";





            console.log("quizAction", quizAction);





            if (


              quizAction === "quizfour" ||


              quizAction === "firstForm" ||


              quizAction === "formTwo"


            ) {


              this.quizBackLink.style.display = "none";


            } else {


              this.quizBackLink.dataset.quizaction = backLinkAction;





              this.quizBackLink.style.display = "flex";


            }


          }


        });





        if (quizAction === "firstForm") {


          this.displayForm(quizAction, 10);


        } else if (quizAction === "formTwo") {


          this.displayForm(quizAction, 11);


        }


      });


    });


  }





  displayForm(quizAction, formIdBase) {


    let currentLanguage = document.documentElement.lang;


    let formId;





    switch (currentLanguage) {


      case "es-ES":


        formId = `${formIdBase + 2}`;


        break;


      case "pt":


        formId = `${formIdBase + 4}`;


        break;


      default:


        formId = `${formIdBase}`;


        break;


    }





    const form = document.querySelector(


      `.footer__quiz-answers-forms #gform_wrapper_${formId}`


    );





    if (form) {


      form.style.display = "block";





      this.handleFormBackLink(quizAction, form);


    }


  }





  handleFormBackLink(quizAction, form) {


    const backToPrevious = document.querySelector(".footer__back-to-previous");


    backToPrevious.classList.add("back-to-previous--visible");





    backToPrevious.addEventListener("click", () => {


      form.style.display = "none";


      backToPrevious.classList.remove("back-to-previous--visible");





      if (quizAction === "firstForm") {


        this.quizItems.forEach((quizItem) => {


          quizItem.style.display = "none";





          if (quizItem.dataset.quizid === "firstQuiz") {


            quizItem.style.display = "block";


          }


        });


      } else {


        this.quizItems.forEach((quizItem) => {


          quizItem.style.display = "none";





          if (quizItem.dataset.quizid === "quizThree") {


            quizItem.style.display = "block";


            this.quizBackLink.style.display = "flex";


          }


        });


      }


    });





    jQuery(document).on("gform_confirmation_loaded", function (event, formId) {


      if (


        document.querySelector(


          ".footer__back-to-previous.back-to-previous--visible"


        )


      ) {


        document.querySelector(


          ".footer__back-to-previous.back-to-previous--visible"


        ).style.display = "none";


      }





      document.querySelector(".footer__top-text").style.display = "none";


      document.querySelector(".footer__normal-text").style.display = "none";


    });


  }





  handleQuizBackLink() {


    this.quizBackLink.addEventListener("click", () => {


      const quizAction = this.quizBackLink.dataset.quizaction;





      this.quizItems.forEach((quizItem) => {


        quizItem.style.display = "none";





        if (quizItem.dataset.quizid === quizAction) {


          const backLinkAction =


            quizItem.closest(".footer__quiz").previousElementSibling.dataset


              .quizid;





          this.quizBackLink.dataset.quizaction = backLinkAction;





          quizItem.style.display = "block";


        }


      });





      if (quizAction === "firstQuiz" || quizAction === "quizfour") {


        this.quizBackLink.style.display = "none";


      }


    });


  }





  async injectMenuItems() {


    const menuWrapper = document.querySelector(".desktop-menu-wrapper");


    let currentLanguage = document.documentElement.lang;





    try {


      let response = await fetch(


        `${origin}/wp-json/general-injection/v1/options`


      );





      if (currentLanguage === "es-ES") {


        response = await fetch(


          `${origin}/es/wp-json/general-injection/v1/options`


        );


      } else if (currentLanguage === "pt") {


        response = await fetch(


          `${origin}/pt/wp-json/general-injection/v1/options`


        );


      }





      const data = await response.json();


      data.forEach((html) => {


        menuWrapper.innerHTML += html.html;


      });





      this.handleInjectedMenu();


    } catch (error) {


      console.error(error);


    }


  }





  handleInjectedMenu() {


    const menuWrapper = document.querySelector(".desktop-menu-wrapper");


    const menuItemWithChildren = document.querySelectorAll(


      ".dropdown-menu-item.menu-item"


    );





    menuItemWithChildren.forEach((menuItem) => {


      menuItem.addEventListener("mouseover", (e) => {


        if (window.innerWidth > 991) {


          const elements = document.querySelectorAll("[data-parentitem]");





          menuWrapper.classList.add("menu-visible");


          document


            .querySelector(".header__navbar")


            .classList.add("element-blured");





          elements.forEach((element) => {


            element.classList.remove("child-level-visible");


          });





          for (let i = 0; i < menuItem.classList.length; i++) {


            const className = menuItem.classList[i];





            if (className.startsWith("childrens-")) {


              const menuItemChildElement = document.querySelector(


                `[data-parentitem="${className}"]`


              );





              menuItemChildElement.classList.add("child-level-visible");


            }


          }


        }


      });





      menuItem.addEventListener("mouseleave", (e) => {


        if (window.innerWidth > 991) {


          // menuWrapper.classList.remove("menu-visible");


          // document


          //   .querySelector(".header__navbar")


          //   .classList.remove("element-blured");





          if (!document.querySelector(".header:hover")) {


            menuWrapper.classList.remove("menu-visible");


            document


              .querySelector(".header__navbar")


              .classList.remove("element-blured");


          }


        }


      });





      menuItem.addEventListener("click", () => {


        if (window.innerWidth < 992) {


          const elements = document.querySelectorAll("[data-parentitem]");





          menuWrapper.classList.add("menu-visible");





          if (document.querySelector(".sub-menu.sub-menu-visible")) {


            document


              .querySelector(".sub-menu.sub-menu-visible")


              .classList.remove("sub-menu-visible");


          }





          for (let i = 0; i < menuItem.classList.length; i++) {


            const className = menuItem.classList[i];





            if (className.startsWith("childrens-")) {


              const menuItemChildElement = document.querySelector(


                `[data-parentitem="${className}"]`


              );





              if (


                menuItemChildElement.classList.contains("child-level-visible")


              ) {


                menuItemChildElement.classList.remove("child-level-visible");


                menuItem


                  .querySelector(".sub-menu")


                  .classList.remove("sub-menu-visible");


                // document


                //   .querySelector("body")


                //   .classList.remove("element-blured");


              } else {


                elements.forEach((element) => {


                  element.classList.remove("child-level-visible");


                });





                menuItemChildElement.classList.add("child-level-visible");


                menuItem


                  .querySelector(".sub-menu")


                  .classList.add("sub-menu-visible");





                // document.querySelector("body").classList.add("element-blured");


              }


            }


          }


        }


      });


    });





    menuWrapper.addEventListener("mouseover", (e) => {


      if (window.innerWidth > 991) {


        menuWrapper.classList.add("menu-visible");


        document


          .querySelector(".header__navbar")


          .classList.add("element-blured");


      }


    });





    menuWrapper.addEventListener("mouseleave", (e) => {


      if (window.innerWidth > 991) {


        if (


          document.querySelector(".header__navbar:hover") ||


          !document.querySelector(".header:hover")


        ) {


          menuWrapper.classList.remove("menu-visible");


          document


            .querySelector(".header__navbar")


            .classList.remove("element-blured");


        }


      }


    });





    window.addEventListener("scroll", function () {


      if (window.innerWidth > 991) {


        menuWrapper.classList.remove("menu-visible");


        document


          .querySelector(".header__navbar")


          .classList.remove("element-blured");


      }


    });


  }





  handleCloseMenu() {


    this.mainElement.addEventListener("click", () => {


      this.resetMenu();


    });


  }





  handleTopHeaderLoginLink() {


    this.topHeaderLoginLinks.forEach((loginLink) => {


      loginLink.addEventListener("click", (e) => {


        e.preventDefault();





        this.mainElement.classList.add("element-blured-form");


        this.bodyElement.classList.add("element-blured-form");


        this.loginForm.classList.add("form-visible");





        this.clearMainElement();


        this.handleCloseForm();


      });


    });


  }





  resetMenu() {


    const activeItem = document.querySelector(


      ".dropdown-menu-item.child-level-visible"


    );


    const dropdownMenu = document.querySelector(".header__dropdown-wrapper");





    if (activeItem) {


      activeItem.classList.remove("child-level-visible");


    }





    if (dropdownMenu) {


      document.querySelector(".header__dropdown-wrapper").remove();


    }





    if (document.querySelector(".sub-menu.sub-menu-visible")) {


      document


        .querySelector(".sub-menu.sub-menu-visible")


        .classList.remove("sub-menu-visible");


    }





    this.bodyElement.classList.remove("element-blured");


    this.mainElement.classList.remove("element-blured");


  }





  clearMainElement() {


    document.querySelector("#main").addEventListener("click", () => {


      this.removeElementClasses();


    });


  }





  handleCloseForm() {


    this.closeLoginFormIcon.addEventListener("click", () => {


      this.removeElementClasses();


    });


  }





  openMobileMenu() {


    this.mobileOpen.addEventListener("click", () => {


      this.mobileOpen.style.display = "none";


      this.mobileClose.style.display = "block";


      this.menuWrapper.classList.add("menu-visible");


      this.bodyElement.classList.add("element-blured");





      this.closeMobileMenu();


    });


  }





  closeMobileMenu() {


    this.mobileClose.addEventListener("click", () => {


      this.mobileOpen.style.display = "block";


      this.mobileClose.style.display = "none";


      this.menuWrapper.classList.remove("menu-visible");


      this.bodyElement.classList.remove("element-blured");


      document


        .querySelector(".desktop-menu-wrapper")


        .classList.remove("menu-visible");


      document


        .querySelector(".child-level-visible")


        ?.classList.remove("child-level-visible");





      if (document.querySelector(".go-back")) {


        document.querySelector(".go-back").remove();


      }





      this.menuTopItems.forEach((item) => {


        item.classList.remove("child-level-visible");


      });





      if (document.querySelector(".sub-menu.sub-menu-visible")) {


        document


          .querySelector(".sub-menu.sub-menu-visible")


          .classList.remove("sub-menu-visible");


      }





      this.removeElementClasses();


    });


  }





  handleActiveItem() {


    const activeItem = document.querySelector(".go-back");





    if (activeItem) {


      activeItem.addEventListener("click", () => {


        document.querySelector(".header__dropdown-wrapper").remove();





        this.menuTopItems.forEach((item) => {


          item.classList.remove("child-level-visible");


          item.style.display = "flex";


        });





        activeItem.remove();


      });


    }


  }





  removeElementClasses() {


    document.querySelector("#main").classList.remove("element-blured");


    this.bodyElement.classList.remove("element-blured");


    document.querySelector("#main").classList.remove("element-blured-form");


    this.bodyElement.classList.remove("element-blured-form");


    this.loginForm.classList.remove("form-visible");


  }





  handleDropdownLinks() {


    document


      .querySelector(".header__dropdown-links")


      .addEventListener("click", (e) => {


        e.stopPropagation();


      });


  }


}





new SiteFunctions();


